export const Heading_Collaborte_form_Trusted_Businesses = {
  Heading: "Ready to ",
  span_heading: "Collaborate?"
}


export const Collaborte_form_Trusted_Businesses = {
  section1: {
    title: "1. About Yourself",
    fields: {
      name: "Your Name",
      email: "Your Email",
      phone: "Phone",
      company: "Company Name (Optional)",
    },
  },
  section2: {
    title: "2. About Your Project",
    fields: {
      projectType: {
        placeholder: "What are you building",
        options: [
          { value: "web", label: "Website" },
          { value: "app", label: "Mobile App" },
          { value: "crm", label: "CRM" },
          { value: "custom-software", label: "Custom Software Solutions" },
          { value: "branding", label: "Branding" },
          { value: "digital-marketing", label: "Digital Marketing" },
          { value: "e-commerce", label: "E-commerce" },
          { value: "erp", label: "ERP" },
          { value: "ai", label: "AI" },
          { value: "blockchain", label: "Blockchain" },
          { value: "cybersecurity", label: "Cybersecurity" },
          { value: "data-analytics", label: "Data Analytics" },
          { value: "data-science", label: "Data Science" },
          { value: "data-visualization", label: "Data Visualization" },
          { value: "data-warehousing", label: "Data Warehousing" },
        ],
      },
      idea: "Tell us more about your idea",
      budget: {
        placeholder: "Your Ideal Budget Range",
        options: [
          { value: "2k+", label: "$2k+" },
          { value: "5k+", label: "$5k - $10k" },
          { value: "10k+", label: "$10k - $20k" },
          { value: "50k+", label: "$50k - $100k" },
          { value: "100k+", label: "$100k+" },
          { value: "not-sure", label: "Not sure" },
        ],
      },
      timeline: {
        placeholder: "Timeline / Urgency",
        options: [
          { value: "asap", label: "ASAP" },
          { value: "1-month", label: "1 Month" },
          { value: "flexible", label: "Flexible" },
        ],
      },
      referral: {
        placeholder: "How’d you hear about us?",
        options: [
          { value: "google", label: "Google" },
          { value: "social", label: "Social Media" },
          { value: "friend", label: "Friend or Referral" },
          { value: "other", label: "Other" },
        ],
      },
    },
  },
  submitText: "Submit Request",
  privacyText: "By clicking Submit Request, you acknowledge that you have read our",
  privacyLink: "/privacy-policy",
  successDialog: {
    title: "Thank You!",
    description:
      "We've received your request and truly appreciate you reaching out to us.",
    followUp:
      "Our team will review your details and get back to you soon. We look forward to connecting with you!",
    closeText: "Got it",
  },
};